import styled from 'styled-components';

import { breakpoints, Button, theme } from '@notino/react-styleguide';

import { Divider } from '../styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledDivider = styled(Divider)`
  margin: 0.5rem 0;
`;

export const LineThrough = styled.span`
  text-decoration: line-through;
  white-space: nowrap;
`;

export const Percentage = styled.span`
  margin-left: 6px;
  color: ${theme.color.text.highlight};
`;

export const RowWithIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 0.2rem;

  svg {
    cursor: pointer;
  }
`;

export const ModalContent = styled.div`
  padding: 1.25rem;
  @media (min-width: ${breakpoints.md}) {
    padding: 2.5rem 0 0;
  }
`;

export const ListItems = styled.div`
  gap: 1rem;
  display: flex;
  flex-direction: column;

  p {
    display: flex;
    gap: 0.25rem;
  }
`;

export const MoreInfoLink = styled.a`
  display: block;
  color: ${theme.color.text.primary};
  ${theme.typography.labelRegular};
  margin: 1.5rem 0 2rem;
`;

export const OkButton = styled(Button)`
  width: 100%;
  margin-inline: auto;
  display: block;

  @media (min-width: ${breakpoints.md}) {
    width: auto;
    min-width: 200px;
  }
`;
